import { useTriggerEvent } from 'hooks/useTriggerEvent'
import { useTranslation } from 'services/i18n'
import { useClosePanel, useIsPanelOpen } from 'stores/usePanelsStateStore'
import { cn } from 'utils/cn'

export const ConversationMenuPanelOverlay = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'conversation_history',
  })
  const triggerEvent = useTriggerEvent()

  const isConversationMenuPanelOpen = useIsPanelOpen('conversations_menu')
  const closePanel = useClosePanel()

  const onMenuClose = () => {
    closePanel('conversations_menu')

    triggerEvent({ name: 'kai_sidepanel_closed' })
  }

  return (
    <button
      type="button"
      aria-label={t('close_conversation_sidepanel')}
      className={cn(
        'xl:hidden h-screen w-screen bg-black/20 fixed z-[11] right-0 bottom-0 print:hidden',
        {
          'opacity-0 pointer-events-none': !isConversationMenuPanelOpen,
          'opacity-100': isConversationMenuPanelOpen,
        },
      )}
      onClick={onMenuClose}
    />
  )
}
